import * as React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';

import AdsOutOfPage from '_components/AdsOutOfPage';
import ArticleList from '_components/article-v3/ArticleList';
import Layout from '_components/layout';
import SEO from '_components/seo_v3';
import { isEmpty } from 'lodash';

function Page({ pageContext }) {
  const [category] = useQueryParam('category', StringParam);
  const [query] = useQueryParam('query', StringParam);
  const [tag] = useQueryParam('tag', StringParam);
  const [make] = useQueryParam('make', StringParam);

  const { allCategories, allArticles } = pageContext;

  let filteredArticles = [];

  let makeName = null;
  let searchTitle = "Search Results";

  if (tag) {
    searchTitle = `Filtered results for ${tag}`;
    filteredArticles = allArticles.filter((a) =>
      a.tags_v3.find((t) => t.name === tag),
    );
  }
  else if (make) {
    searchTitle = `Filtered results for ${make}`;
    filteredArticles = allArticles.filter((a) => {
      if (
        category &&
        category !== 'all' &&
        a.category_v3?.slug.current !== category
      ) {
        return false;
      }
      
      if (a.make) {
        if (a.make.name.toLowerCase().includes(make.toLowerCase())){
          makeName = a.make.name;
          return true;
        }
      }
      return false;
    });
    
    if (makeName) {
      searchTitle = `Filtered results for ${makeName}`;
    }

  }
  else if (query) {
    searchTitle = `Search results for ${query}`;
    filteredArticles = allArticles.filter((a) => {
      if (
        category &&
        category !== 'all' &&
        a.category_v3?.slug.current !== category
      ) {
        return false;
      }
      return a.title.toLowerCase().includes(query.toLowerCase());
    });
  }
  else {
    searchTitle = `All articles`;
    filteredArticles = allArticles.filter((a) => {
      if (
        category &&
        category !== 'all' &&
        a.category_v3?.slug.current !== category
      ) {
        return false;
      }
      return true
    });
  }

  const categoryObject = allCategories.find((c) => c.slug.current === category);

  return (
    <Layout
      headerProps={{ activeKey: '/articles' }}
      v3
      showArticleSearchBar
    >
      <ArticleList
        articles={filteredArticles}
        searchQuery={query}
        category={categoryObject}
        title={searchTitle}
      />
      <AdsOutOfPage
        desktop={{
          adsId:
            '/325540922/oneshift_web/desktop_article_search_oop_interstitial_01',
          sizes: [[1024, 768]],
        }}
        mobile={{
          adsId:
            '/325540922/oneshift_web/mobile_article_search_oop_interstitial_01',
          sizes: [[320, 480]],
        }}
        divId="articles-search-oop-ads"
      />
    </Layout>
  );
}

export const Head = ({ location, params, data, pageContext }) => {
  const title = `Search Articles | OneShift by Carousell`
  return <SEO title={title} pathname={location.pathname} /> 
}

export default Page;
